/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import nikeStoreCountries from '../../../utils/static/countriesWithNikeStores';

const ConsumerDetails = ({
  customerDetails
}) => {
  const {
    RL_Address, RL_Name, RL_Phone, redacted, isAdmin
  } = useSelector((state) => state);
  const customer = customerDetails?.[0];
  const address = customer?.Addresses?.[0];
  const telephone = customer?.TelephoneNumbers?.[0];
  const maskData = (value) => (isAdmin ? value : redacted);

  const formatAddress = () => {
      if (!isAdmin) return redacted;
      if (!address) return '';

    const city = address?.City ? `${address.City},` : '';
    const stateOrProvince = address?.StateOrProvince ? `${address.StateOrProvince},` : '';
    const PostalCode = address?.PostalCode ? `${address.PostalCode},` : '';
    const Country = address?.Country ? `${nikeStoreCountries.find((country) => country.value === address.Country)?.label || address.Country}` : '';
    const address2 = `${city} ${stateOrProvince} ${PostalCode} ${Country}`;
    const addressLines = address?.AddressLines?.map((line) => line.Line).filter(Boolean).join(', ') || '';
    return addressLines ? `${addressLines}, ${address2}` : address2;
  };

  return (
    <section key="ConsumerDetails">
      <br />
      <p>*****Consumer Details*****</p>
      <article className="justify-between">
        <p>{`${RL_Name}: ${maskData(customer?.Name?.FullName || '')}`}</p>
      </article>
      <article className="justify-between">
        <p>{`${RL_Phone}: ${maskData(telephone?.Number || '')}`}</p>
      </article>
      <article className="ta-sm-l">
        <p>{`${RL_Address}: ${formatAddress()}`}</p>
      </article>
      <article className="justify-between">
        <p>{`Customer GSTN: ${maskData(customer?.ID || 'Unregistered')}`}</p>
      </article>
      <br />
    </section>
  );
};

const ConsumerContact = ({
  customerDetails
}) => {
  const {
    RL_Name, RL_Phone, RL_Email, RL_Contact, isAdmin, redacted
  } = useSelector((state) => state);
  const customer = customerDetails?.[0];
  const telephone = customer?.TelephoneNumbers?.[0];
  const email = customer?.EMail?.EMailAddress;
  const maskData = (value) => (isAdmin ? value : redacted);

  return (
    <section key="ConsumerDetails">
      <br />
      <p>*** {RL_Contact} ***</p>
      <article className="justify-between">
        <p>{`${RL_Name}: ${maskData(customer?.Name?.FullName || '')}`}</p>
      </article>
      <article className="justify-between">
        <p>{`${RL_Phone}: ${maskData(telephone?.Number || '')}`}</p>
      </article>
      <article className="justify-between">
        <p>{`${RL_Email}: ${maskData(email || '')}`}</p>
      </article>
    </section>
  );
};

ConsumerDetails.propTypes = {
  customerDetails: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

ConsumerContact.propTypes = {
  customerDetails: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export { ConsumerDetails, ConsumerContact };
